import { Shield, Lock, Users, Database, AlertTriangle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export function SecurityOverview() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* RBAC System */}
      <Card className="border-blue-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="w-5 h-5 text-blue-600" />
            نظام RBAC
          </CardTitle>
          <CardDescription>
            التحكم بالوصول بناءً على الأدوار
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm">الحالة</span>
            <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
              يتطلب Migration
            </Badge>
          </div>
          <div className="text-xs text-muted-foreground">
            نظام متقدم لإدارة الأدوار مع تسلسل هرمي ووراثة الصلاحيات
          </div>
          <div className="pt-2 border-t">
            <p className="text-xs font-medium mb-2">الأدوار المتوفرة:</p>
            <div className="flex flex-wrap gap-1">
              <Badge variant="secondary" className="text-xs">super_admin</Badge>
              <Badge variant="secondary" className="text-xs">admin</Badge>
              <Badge variant="secondary" className="text-xs">manager</Badge>
              <Badge variant="secondary" className="text-xs">sales</Badge>
              <Badge variant="secondary" className="text-xs">+6 more</Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* RLS System */}
      <Card className="border-green-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="w-5 h-5 text-green-600" />
            نظام RLS
          </CardTitle>
          <CardDescription>
            أمان على مستوى الصف في قاعدة البيانات
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm">الحالة</span>
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
              مفعل جزئياً
            </Badge>
          </div>
          <div className="text-xs text-muted-foreground">
            Policies محسّنة لحماية البيانات على مستوى الجداول
          </div>
          <div className="pt-2 border-t">
            <p className="text-xs font-medium mb-2">الجداول المحمية:</p>
            <div className="flex flex-wrap gap-1">
              <Badge variant="secondary" className="text-xs">employees</Badge>
              <Badge variant="secondary" className="text-xs">clients</Badge>
              <Badge variant="secondary" className="text-xs">bookings</Badge>
              <Badge variant="secondary" className="text-xs">+15 more</Badge>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Frontend Guards */}
      <Card className="border-purple-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Shield className="w-5 h-5 text-purple-600" />
            Frontend Guards
          </CardTitle>
          <CardDescription>
            حماية المسارات في الواجهة
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm">الحالة</span>
            <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">
              مفعل
            </Badge>
          </div>
          <div className="text-xs text-muted-foreground">
            Components متقدمة لحماية المسارات بناءً على الأدوار والصلاحيات
          </div>
          <div className="pt-2 border-t">
            <p className="text-xs font-medium mb-2">المكونات:</p>
            <div className="space-y-1 text-xs">
              <div>✓ RoleProtectedRoute</div>
              <div>✓ ProtectedRoute</div>
              <div>✓ AuthGuard</div>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Audit System */}
      <Card className="border-orange-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-orange-600" />
            نظام التدقيق
          </CardTitle>
          <CardDescription>
            تسجيل ومراقبة العمليات الحساسة
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm">الحالة</span>
            <Badge variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
              يتطلب Migration
            </Badge>
          </div>
          <div className="text-xs text-muted-foreground">
            سجلات شاملة لتتبع التغييرات ومحاولات الوصول
          </div>
          <div className="pt-2 border-t">
            <p className="text-xs font-medium mb-2">المميزات:</p>
            <div className="space-y-1 text-xs">
              <div>• role_assignment_log</div>
              <div>• access_denial_log</div>
              <div>• activity_logs (مفعل)</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
